import {inject, injectable} from "inversify";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {AbstractApiProvider} from "data/providers/api/abstract.api.provider";
import {CouponType} from "data/enums";

export interface ICoupon {
	type: CouponType;
	imageUrl: string;
	code: string;
}

type TCouponResponse = IApiResponse<{coupons: ICoupon[]}>;

export interface ICouponApiProvider {
	get: () => Promise<AxiosResponse<TCouponResponse>>;
}

@injectable()
export class CouponApiProvider extends AbstractApiProvider implements ICouponApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {
		super();
	}

	get = () => this._http.get<TCouponResponse>(`${this.language}/coupon/list`);
}
